import { UserAuthWrapper } from 'redux-auth-wrapper';
import { replace } from '../services/router-utils';
import URI from 'urijs';

/* eslint-disable */
const requireAuth = UserAuthWrapper({
  authSelector: state => state.auth,
  predicate: auth => auth.isAuthenticated,
  wrapperDisplayName: 'requireAuth',
  redirectAction: args => {
    if (args.query.redirect) {
      args.query.redirect = URI(args.query.redirect).search('').toString();
    }
    return replace(args);
  },
});
/* eslint-enable */

export default requireAuth;



// WEBPACK FOOTER //
// ./app/hoc/require-auth.js